import React, { Component } from 'react';
import SummaryCategoryItem from './SummaryCategoryItem';


export default class SummaryCategoryItems extends Component {

	render() {
		const { categories, selectedDates, amountDisplayed, totalToShowPercentageOf, categoryMouseEnter, categoryMouseLeave } = this.props;
		return (
			<React.Fragment>
				{categories.length > 0 &&
				<div className='collection'>
					{categories.map((category) => {
						return <SummaryCategoryItem
							key={category.id || category.instanceNumber}
							category={category}
							selectedDates={selectedDates}
							amountDisplayed={amountDisplayed}
							totalToShowPercentageOf={totalToShowPercentageOf}
							categoryMouseEnter={categoryMouseEnter}
							categoryMouseLeave={categoryMouseLeave}
						/>;
					})}
				</div>
				}
				{categories.length === 0 &&
				<div>
					<h5>Nothing!</h5>
				</div>
				}
			</React.Fragment>

		);

	}
}